// extracted by mini-css-extract-plugin
export default {"body":"ScreeningFailedStep_body__S6NKj","errorSection":"ScreeningFailedStep_errorSection__Lj2X3","errorHeader":"ScreeningFailedStep_errorHeader__XRjAj"};